<template>
    <header>
        <div class="header-inner">
            <router-link id="link-home" to="/">
                <img src="../assets/images/common/melchi-logo.png">
                <span><!--멸치패밀리 사이트-->{{$t("headerBar.code001")}}</span>
            </router-link>
            <div v-if="this.$store.state.isAuth" class="user-menu">
                <router-link to="/audio" :class="[this.$route.path == '/font'?'router-link-active':'']"><!--무료 오디오 & 폰트-->{{$t("headerBar.code002")}}</router-link>
                |
                <router-link to="/notice"><!--공지사항-->{{$t("headerBar.code003")}}</router-link>
                |
                <router-link to="/faq"><!--FAQ-->{{$t("headerBar.code004")}}</router-link>
                |
                <router-link to="/operation-policies" :class="[this.$route.path == '/profit-policies'?'router-link-active':'']"><!--운영정책-->{{$t("headerBar.code005")}}</router-link>
                |
                <a class="user-info" @mouseenter="showLoggedInMenu" @mouseleave="hideLoggedInMenu">
                    <span class="inner"><strong>{{this.$store.state.userName}}</strong></span>
                </a>
                <div class="logged-in-menu" v-show="displayLoggedInMenu" @mouseenter="showLoggedInMenu" @mouseleave="hideLoggedInMenu">
                    <router-link to="/mypage"><!--나의 정보-->{{$t("headerBar.code006")}}</router-link>
                    <router-link to="/qna"><!--1:1문의-->{{$t("headerBar.code007")}}</router-link>
                    <a @click="onLogout"><!--로그아웃-->{{$t("headerBar.code008")}}</a>
                </div>
            </div>
            <div v-else class="user-menu">
                <router-link to="/audio" :class="[this.$route.path == '/font'?'router-link-active':'']"><!--무료 오디오 & 폰트-->{{$t("headerBar.code002")}}</router-link>
                |
                <router-link to="/notice"><!--공지사항-->{{$t("headerBar.code003")}}</router-link>
                |
                <router-link to="/faq"><!--FAQ-->{{$t("headerBar.code004")}}</router-link>
                |
                <router-link to="/operation-policies" :class="[this.$route.path == '/profit-policies'?'router-link-active':'']"><!--운영정책-->{{$t("headerBar.code005")}}</router-link>
                |
                <router-link to="/login"><!--로그인-->{{$t("headerBar.code009")}}</router-link>
                |
                <router-link to="/signup/form" :class="[this.$route.path == '/signup/form'?'router-link-active':'']"><!--회원가입-->{{$t("headerBar.code010")}}</router-link>
            </div>
            <div class="gnb">
                <router-link to="/" exact><!--멸치패밀리 홈-->{{$t("headerBar.code011")}}</router-link>
                <router-link to="/introduction"><!--멸치패밀리 소개-->{{$t("headerBar.code012")}}</router-link>
                <router-link to="/jobs"><!--일거리 현황-->{{$t("headerBar.code013")}}</router-link>
                <router-link to="/my-entry-list"><!--내 출품 현황-->{{$t("headerBar.code014")}}</router-link>
                <router-link to="/my-asset"><!--내 자산 현황-->{{$t("headerBar.code015")}}</router-link>
            </div>
        </div>
    </header>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex' // mapGetters를 추가한다

    export default {
        computed: {
            isLogin() {
                return this.$store.state.isAuth
            },
        },
        created: function () {
            if (this.$store.state.isAuth) { // 로그인시
                this.isCastingn = localStorage.getItem('isCastingn')
                if (this.isCastingn) {
                    this.$api.saveCastingn() 
                }
            } 
        },
        mounted: function() {

        },
        data: function () {
            return {
                displayLoggedInMenu: false,
                isCastingn: false
            }
        },
        methods: {
            ...mapActions(['logout']),
            onLogout: function () {
                this.logout();
            },
            showLoggedInMenu: function () {
                this.displayLoggedInMenu = true;
            },
            hideLoggedInMenu: function () {
                this.displayLoggedInMenu = false;
            },
            toggleLoggedInMenu: function () {
                if (this.displayLoggedInMenu) {
                    this.hideLoggedInMenu();
                } else {
                    this.showLoggedInMenu();
                }
            }
        }
    }
</script>

<style lang="scss">
    header {

        position: relative;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
        z-index: 100;

        div.header-inner {
            width: 1080px;
            height: 116px;
            margin: 0 auto;
            position: relative;

            a#link-home {
                display: inline-block;
                position: absolute;
                top: 50px;
                left: 0;

                span {
                    color: #1665b6;
                    font-size: 18px;
                    margin-left: 9px;
                }
            }

            div.user-menu {
                display: inline-block;
                position: absolute;
                right: 19px;
                top: 21px;
                color: #666666;
                font-size: 14px;

                a {
                    font-size: 14px;
                    display: inline-block;
                    color: #666666;
                    padding: 0 5px;
                }

                a.user-info {
                    cursor: pointer;
                    margin-left: 5px;
                    display: inline-block;
                    padding-left: 25px;
                    padding-bottom: 15px;
                    background: url("../assets/images/common/user-info-icon.png") left 3px no-repeat;

                    span {
                        display: block;
                        background: url("../assets/images/common/user-info-icon-arrow.png") right 70% no-repeat;
                        padding-right: 32px;
                        padding-top: 5px;
                    }
                }

                div.logged-in-menu {
                    position: absolute;
                    right: 0;
                    top: 28px;
                    display: inline-block;
                    width: 130px;
                    background: #ffffff;
                    z-index: 101;
                    border: 1px solid #cfcfcf;
                    border-top: 3px solid #4796fa;

                    a {
                        cursor: pointer;
                        display: block;
                        text-align: left;
                        padding: 12px 20px 12px 32px;
                        border-top: 1px solid #cfcfcf;
                    }

                    a:hover {
                        color: #0099ff;
                    }
                }

                div.logged-in-menu {

                }

                a.router-link-active, a.router-link-exact-active {
                    color: #1665b6;
                }
            }

            div.gnb {
                position: absolute;
                right: 0;
                display: inline-block;
                bottom: 13px;

                a {
                    display: inline-block;
                    margin: 0 19px;
                    padding-bottom: 9px;
                    color: #434158;
                    border-bottom: 3px solid #ffffff;
                }

                a.router-link-active, a.router-link-exact-active {
                    color: #0099ff;
                    border-bottom: 3px solid #0099ff;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/HeaderBar.vue